module.exports = __webpack_public_path__ + "static/img/p2.4620cceb.jpg";